import { gql } from '@apollo/client';

// Champs `user` dont l'app a besoin au démarrage (GET_USER) ET que renvoie la mutation `signup`. Les deux
// documents partagent CE fragment pour qu'ils ne puissent pas diverger : le payload de création suffit alors
// à amorcer le cache Apollo de GET_USER, sans relecture. C'est indispensable pour `roles`, qui décide de
// l'accès aux sites (`User.canAccessTotem`) : l'API le calcule sur l'utilisateur tout juste écrit, alors
// qu'une relecture dans la seconde qui suit peut partir sur un secondaire MongoDB pas encore à jour.
export const USER_FRAGMENT = gql`
    fragment UserFragment on User {
        _id
        createdAt
        username
        emails {
            address
            verified
        }
        roles
        profile {
            firstname
            lastname
            organizationId
            organizationName
            phone
            jobTitle
            imageUrl
            hasOptedOutOfEmail
            hasOptedOutOfReminderEmail
            hasOptedOutOfSoldOutProductsEmail
        }
        visitedSites {
            _id
        }
    }
`;
